module.exports = __webpack_public_path__ + "img/hessen.0ed4d9e.webp";